import { Clock, Brain, SkipForward, CheckCircle } from 'lucide-react';

interface GameStatsProps {
  stats: {
    viewed: number;
    skipped: number;
    total: number;
  };
  questionsInCurrentSession: number;
  questionsPerMinute: number;
  isTimerRunning: boolean;
}

export const GameStats: React.FC<GameStatsProps> = ({ 
  stats, 
  questionsInCurrentSession,
  questionsPerMinute,
  isTimerRunning 
}) => {
  return (
    <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
        <h4 className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
          <CheckCircle className="w-4 h-4 text-blue-600 dark:text-blue-400" />
          Questions Viewed
        </h4>
        <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">{stats.viewed}</p>
      </div>
      <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <h4 className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
          <SkipForward className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
          Skipped
        </h4>
        <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">{stats.skipped}</p>
      </div>
      <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
        <h4 className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
          <Brain className="w-4 h-4 text-green-600 dark:text-green-400" />
          Current Session
        </h4>
        <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">{questionsInCurrentSession}</p>
      </div>
      <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
        <h4 className="font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
          <Clock className="w-4 h-4 text-purple-600 dark:text-purple-400" />
          Questions/min
        </h4>
        <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">
          {isTimerRunning ? questionsPerMinute : '-'}
        </p>
      </div>
    </div>
  );
};